import { defineAsyncComponent, type Component } from "vue";
import type { RecodeType } from "@/composables/useRecodeTypeItems";

const RecodeConditionsForm = defineAsyncComponent(() => import("./RecodeConditionsForm.vue"));
const RecodeOpenEndForm = defineAsyncComponent(() => import("./RecodeOpenEndForm.vue"));
const RecodeAiChatForm = defineAsyncComponent(() => import("./RecodeAiChatForm.vue"));
const RecodeMailingForm = defineAsyncComponent(() => import("./RecodeMailingForm.vue"));
const RecodeUrlParamForm = defineAsyncComponent(() => import("./RecodeUrlParamForm.vue"));
const RecodeGeoForm = defineAsyncComponent(() => import("./RecodeGeoForm.vue"));
const RecodeGroupAnswersForm = defineAsyncComponent(() => import("./RecodeGroupAnswersForm.vue"));

const RECODE_TYPE_TO_COMPONENT: Record<RecodeType, Component> = {
  conditions: RecodeConditionsForm,
  open_end: RecodeOpenEndForm,
  interview_codification: RecodeAiChatForm,
  mailing: RecodeMailingForm,
  url_param: RecodeUrlParamForm,
  geo: RecodeGeoForm,
  group_answers: RecodeGroupAnswersForm,
};

export function recodeFormComponent(recodeType: string | null | undefined): Component {
  return RECODE_TYPE_TO_COMPONENT[recodeType as RecodeType] || RecodeConditionsForm;
}
